module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-stone-path-background.5d9fcc08.png";